import { MalwareScanningStatus } from './fileHandle.interface';
import { OptionThumbnail } from './option-version.interface';

export enum ShareLinkAssetEntityTypes {
  SUBSECTION = 'SUBSECTION',
  FOLDER = 'FOLDER',
  SUBFOLDER = 'SUBFOLDER',
  VERSION = 'VERSION',
  FILE = 'FILE',
}

export interface ShareLinkAsset {
  itemId: string;
  subSectionId: string;
  topicId?: string;
  optionId?: string;
  version?: number;
  fileId?: string;
  entityType: ShareLinkAssetEntityTypes;
  name: string;
  transcodeMetadata?: any[];
  filename?: string;
  malwareScanningStatus?: MalwareScanningStatus;
  previewImages?: string[];
  contentTypes?: string;
  sectionName?: string;
  subsectionName?: string;
  signedURL?: string; //for display purpose
  contentType?: string; // for display purpose
  thumbnails?: OptionThumbnail[];
  singleVersionNumber?: number; //to indicate option/subfolder only has one version
  children?: ShareLinkAsset[];
  firstUploaded?: number | null;
  lastUploaded?: number | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  versionId?: string;
}

export interface ShareLink {
  id?: string;
  title: string;
  projectId: string;
  sectionId: string;
  subsectionId: string;
  commentEnabled: boolean;
  creator: string;
  companyId: string;
  isRestricted: boolean;
  password?: string;
  expiration?: number;
  createdAt?: number;
  message?: string;
  participants: string[];
  blacklistedParticipants: string[];
  url?: string;
  assets?: ShareLinkAsset[];
  updatedAt?: number;
  login?: any;
  tree?: ShareLinkAsset[];
  validated?: boolean;
}

export interface ShareListResponse {
  shareLinks: ShareLink[];
  reviewLinkMap: Record<string, number[]>;
  reviewLinkRecord?: Record<string, ShareLink[]>;
}

export interface ShareLinkSimple {
  id: string;
  title: string;
}
